module.exports = __webpack_public_path__ + "img/resource_gold_idols.67bb93cf.png";